export default __webpack_public_path__ + "static/media/video.fe070c97.svg";